var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.messages),function(message,i){return _c('li',{key:i},[_vm._v(_vm._s(message))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }